import React, { useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Container, Grid, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();
  

  // Add Elfsight script loader
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    let userData;

    try {
      userData = JSON.parse(localStorage.getItem('user'));
    } catch (error) {
      console.error("Error parsing JSON data from localStorage:", error);
      userData = null;
    }

    if (userData) {
      
      switch (userData.selectedOption) {
        case "Comesa":
        case "Regional Network":
        case "Member State":
          navigate("/home");
          break;
        default:
          navigate("/"); 
      }
    } else {
     
      const accessToken = document.cookie.split('; ').find(row => row.startsWith('accessToken='));

      if (accessToken) {
        navigate('/home'); 
      }
    }

    
    window.history.pushState(null, null, window.location.href);

    
    const handlePopState = (event) => {
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundImage: 'url(./background.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
     
      <AppBar position="static" sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box display="flex" alignItems="center">
          <img
              src="./l2.png"
              alt="COMESA Logo"
              style={{ maxWidth: "50px", marginRight: "16px" }}
            />
           
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Portal
            </Typography>
          </Box>

        
          <Box>
            <Button color="inherit" component={Link} to="/about">
              About
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Add Elfsight widget container */}
      <div className="elfsight-app-f11063c8-6f6e-41a2-b858-6fd2bcd4bff3"></div>

     
      <Container maxWidth="lg" sx={{ marginTop: '100px', textAlign: 'center', paddingLeft: '24px', flexGrow: 1 }}>
        <Typography variant="h3" gutterBottom sx={{ color: 'white' }}>
          EA-SA-IO ICT PORTAL
        </Typography>

      
        <Box
          display="flex" alignItems="center"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px'
          }}
        >
          <Typography variant="h6" paragraph sx={{ marginBottom: '20px', color: 'black' }}>
          The EA-SA-IO ICT Portal is an online platform for monitoring and evaluation of regional ICT Development Initiatives in the Eastern Africa, Southern Africa and the Indian Ocean regions. It enables stakeholders to efficiently collect and analyse data as well as  generate informative reports to enhance decision making and promote ICT growth in the regions.
          </Typography>
        </Box>

      
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            marginTop: '40px'
          }}
        >
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/login"
            sx={{ width: '150px' }}
          >
            Login
          </Button>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/register"
            sx={{ width: '150px' }}
          >
            Sign Up
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ justifyContent: 'center' }}>
         
        </Grid>
      </Container>

  
      {/* <Box
        component="footer"
        sx={{
          backgroundColor: '#333',
          color: '#fff',
          padding: '10px',
          textAlign: 'center',
          marginTop: '50px'
        }}
      > */}
        {/* <Typography variant="body2">
          © {new Date().getFullYear()} EA-SA-IO ICT M&E Portal. All rights reserved.
        </Typography> */}
      {/* </Box> */}
    </Box>
  );
};

export default LandingPage;
